import { render, staticRenderFns } from "./UsersViewMessages.vue?vue&type=template&id=3ce742da&"
import script from "./UsersViewMessages.vue?vue&type=script&lang=js&"
export * from "./UsersViewMessages.vue?vue&type=script&lang=js&"
import style0 from "./UsersViewMessages.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports